import { module } from 'modujs';
import * as CookieConsent from 'vanilla-cookieconsent';

export default class extends module {
    constructor(m) {
        super(m);

        try {
            this.config = JSON.parse(this.getData('config'));
        } catch (err) {
            console.warn(err.message);
        }

        this.events = {
            click: {
                hide: 'hideModal',
                'show-preferences': 'showPreferences'
            },
        };
    }

    init() {
        if (!this.config.categories || Object.keys(this.config.categories).length === 0) {
            console.warn('[CookieConsent]', 'No categories configured.');
            return;
        }

        this.config.categories = this.prepareCategories(this.config.categories);
        this.config.cookie = {
            name: 'cc_cookie_locomotive'
        };

        CookieConsent.run(Object.assign({
            autoShow: false,
            onConsent: () => {
                this.toggleCategoryAnalytics();
            },
            onChange: ({ changedCategories }) => {
                if (changedCategories.includes('analytics')) {
                    this.toggleCategoryAnalytics();
                }
            },
        }, this.config));

        setTimeout(CookieConsent.show, 1000)
    }

    showPreferences() {
        CookieConsent.showPreferences();
    }

    hideModal() {
        CookieConsent.hidePreferences();
        CookieConsent.hide();
    }

    prepareCategories(categories) {
        for (const [ categoryName, categoryData ] of Object.entries(categories)) {
            if (
                categoryData?.autoClear?.cookies &&
                Array.isArray(categoryData.autoClear.cookies) &&
                categoryData.autoClear.cookies.length > 0
            ) {
                categoryData.autoClear.cookies.map((cookie) => {
                    if (
                        cookie?.name &&
                        typeof cookie.name === 'string'
                    ) {
                        const found = cookie.name.match(/^\/(.+)\/([a-z]+)?$/);
                        if (found) {
                            cookie.name = new RegExp(found[1], found[2]);
                        }
                    }

                    return cookie;
                });

                categories[categoryName].autoClear.cookies = categoryData.autoClear.cookies;
            }
        }

        return categories;
    }

    toggleCategoryAnalytics() {
        const isAccepted = CookieConsent?.acceptedCategory('analytics');

        gtag('consent', 'update', {
            'analytics_storage': (isAccepted ? 'granted' : 'denied'),
        });
    }
}
